import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { routeNames } from "../../routes/routes";
import {
  clearStaleClientCookie,
  getPortalClientId,
  getPortalClientLogo,
  getPortalClientUrl,
} from "../../helpers/clientHelper";

// Client logo only: rounded, 44px tall.
// The AssetsWatch logo keeps its normal .nav-logo styling.
const clientLogoStyle = {
  width: "auto",
  height: 44,
  maxWidth: 140,
  objectFit: "contain",
  borderRadius: 12,
};

// Header brand used by both headers (before and after login): the client's logo
// followed by the AssetsWatch logo when the user came from a client site, otherwise
// just the AssetsWatch logo linking home.
const PortalBrandLogos = () => {
  const { loggedinUser } = useAuth();
  const { pathname } = useLocation();
  // In-app page changes don't reload, so re-check here before reading the client logo.
  clearStaleClientCookie(pathname);
  const clientId = getPortalClientId();
  const clientLogo = getPortalClientLogo(loggedinUser);
  const clientPortalUrl = getPortalClientUrl(loggedinUser);

  if (!(clientId > 0 && clientLogo)) {
    return (
      <Link className="navbar-brand" to={routeNames.home.path}>
        <img
          className="nav-logo"
          src="/assets/images/logo-dark.png"
          alt="AssetsWatch"
        />
      </Link>
    );
  }

  const clientLogoImg = (
    <img
      className="nav-logo"
      style={clientLogoStyle}
      src={clientLogo}
      alt="Portal"
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />
  );

  return (
    <div className="navbar-brand d-flex align-items-center" style={{ gap: 24 }}>
      {clientPortalUrl ? (
        <a
          href={clientPortalUrl}
          onClick={(e) => {
            // Same tab, replacing the current page in history.
            e.preventDefault();
            window.location.replace(clientPortalUrl);
          }}
        >
          {clientLogoImg}
        </a>
      ) : (
        clientLogoImg
      )}
      {/* Not clickable when shown next to a client logo. */}
      <img
        className="nav-logo"
        src="/assets/images/logo-dark.png"
        alt="AssetsWatch"
      />
    </div>
  );
};

export default PortalBrandLogos;
